@if (previewImage() && !isProcessed(previewImage())) {
    <div>
        <span class="placeholder">{{ 'flipto.account.Loading' | translate }}.</span>
    </div>
}
@if (previewImage() && isProcessed(previewImage())) {
    <div>
        @if (isUpdating()) {
            <span class="placeholder">{{ 'flipto.account.Loading' | translate }}.</span>
        }

        <div
            class="thumbnail-image thumbnail-has-label thumbnail-label-desktop"
            [ftBackgroundImage]="azureUrl(previewImage(), cdnSuffixForDesktopImage())"
            [hidden]="isUpdating()"
        ></div>
        <br />
        @if (hasMobile(previewImage())) {
            <div
                class="thumbnail-image thumbnail-has-label thumbnail-label-mobile"
                [ftBackgroundImage]="azureUrl(previewImage(), 'small')"
                [hidden]="isUpdating()"
            ></div>
        }
    </div>
}

<!-- The previews GALLERY (v1 emailImagesPreview.html:25-82 — the
     `modals.emailImages.{{vm.emailImageType}}.preview` ftModal). Per-language desktop/mobile
     toggle + Refresh (ftTasks key generate-email-image-{imageUUID}-{code}) + ft-image-ng previews. -->
<ft-modal-overlay [open]="open()">
    @if (open()) {
        <ft-modal-chrome-ng
            [headerText]="headerTextKey() | translate"
            [headerDescription]="'flipto.account.ImagePreviewsModalSummary' | translate"
            doneText="Done"
            size="sm"
            [doneVisible]="true"
            [cancelVisible]="true"
            [footerVisible]="true"
            [footerCancelVisible]="false"
            (done)="closeGallery()"
            (cancel)="closeGallery()"
        >
            <div class="modal-panel" [hidden]="images()?.length">{{ 'flipto.account.ThereAreNoPreviews' | translate }}</div>

            @for (image of images(); track image) {
                <div class="modal-panel preview-editor" [hidden]="!image.imageUUID">
                    <div class="ta-toolbar btn-toolbar">
                        @if (hasMobile(image)) {
                            <div class="ft-btn-group view-switcher-toggle">
                                <button class="ft-btn btn-default btn-desktop" type="button" [class.active]="isDesktop(image)" (click)="setDesktop(image, true)">
                                    <i class="icon ft-icn-device-desktop"></i>
                                </button>
                                <button class="ft-btn btn-default btn-mobile" type="button" [class.active]="!isDesktop(image)" (click)="setDesktop(image, false)">
                                    <i class="icon ft-icn-device-mobile"></i>
                                </button>
                            </div>
                        }

                        <button class="ft-btn btn-refresh ft-btn-text" [disabled]="isImagePending(image)" (click)="onGalleryRefresh(image)">
                            <i class="icon ft-icn-refresh"></i> {{ 'flipto.account.RefreshImage' | translate }}
                        </button>
                    </div>

                    <div class="preview-image-container">
                        <div class="preview-image-content">
                            @if (isDesktop(image)) {
                                <ft-image-ng class="preview-image" [alwaysVisible]="true" [src]="azureUrl(image.imageUUID, cdnSuffixForDesktopImage())" />
                            }
                            @if (!isDesktop(image)) {
                                <ft-image-ng class="preview-image" [alwaysVisible]="true" [src]="azureUrl(image.imageUUID, 'small')" />
                            }

                            <div class="preview-image-loader" [hidden]="!isImagePending(image)">{{ 'flipto.account.Loading' | translate }}</div>
                        </div>
                    </div>

                    <div class="language-code">{{ image.name }}</div>
                </div>
            }
        </ft-modal-chrome-ng>
    }
</ft-modal-overlay>
